














import {Component, Vue} from "vue-property-decorator";
import PendingOrders from "@/api/Order/PendingOrders";
import OrderService from "@/service/OrderService";

@Component
export default class PendingOrdersWarning extends Vue {
  private pendindOrders: PendingOrders | null = null;

  async getPendingOrders() {
    this.pendindOrders = await OrderService.checkForPendingOrders();
  }

  async mounted() {
    await this.getPendingOrders()
  }

  get showOrdersLink() {
    if (
        this.$route.matched.some(({name}) => name === 'customer-orders') ||
        this.$route.matched.some(({name}) => name === 'customer-order-single')
    ) {
      return false;
    }
    return true;
  }
}
